/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const materialiAPI = {
  list: async (params = {}) => {
    const { data } = await apiClient.get('/materiali', { params });
    return data;
  },

  categorie: async () => {
    const { data } = await apiClient.get('/materiali/categorie');
    return data;
  },

  detail: async (id) => {
    const { data } = await apiClient.get(`/materiali/${id}`);
    return data;
  },

  create: async (materiale) => {
    const { data } = await apiClient.post('/materiali', materiale);
    return data;
  },

  update: async (id, materiale) => {
    const { data } = await apiClient.put(`/materiali/${id}`, materiale);
    return data;
  },

  toggleAttivo: async (id, attivo) => {
    const { data } = await apiClient.patch(`/materiali/${id}/attivo`, { attivo });
    return data;
  },
};
